import React, { useMemo } from 'react'
import '../RecordDetailsPage.scss'
import { GraniteDataGrid, Checkbox } from '@tecuity/granite-ui'
import { IconButton } from '@tecuity/granite-ui/IconButton'
import IconSearch from '@tecuity/sos-icons/react/search'
import format from 'date-fns/format'
import { useHistory } from 'react-router'
import moment from 'moment'

const RepresentedBusinessRecords = ({ fieldSettings = {}, records = [] }) => {
  const history = useHistory()

  const template = useMemo(() => {
    const columns = Object.entries(fieldSettings).map(([key, val]) => {
      if (key.indexOf('Date') !== -1) {
        return {
          field: key,
          flex: 0.5,
          headerName: val.DisplayName,
          disableColumnMenu: true,
          type: 'date',
          sortComparator: (v1, v2) =>
            moment(v1, 'MM-DD-YYYY')
              .toDate()
              .getTime()
              .toString()
              .localeCompare(moment(v2, 'MM-DD-YYYY').toDate().getTime().toString()),
        }
      }
      return {
        field: key,
        flex: 0.5,
        headerName: val.DisplayName,
        disableColumnMenu: true,
      }
    })
    columns.unshift({
      field: 'view',
      width: 70,
      headerName: 'View',
      disableColumnMenu: true,
      renderCell: (params) => {
        if (params) {
          return (
            <div style={{ margin: 'auto' }}>
              <span title="View Record">
                <IconButton
                  onClick={() => {
                    history.push(`/recordDetails/BusinessEntitySearch/${params.row.RecordNum}`)
                  }}
                  icon={<IconSearch />}
                  label="View Record"
                />
              </span>
            </div>
          )
        }
      },
    })
    return columns
  }, [fieldSettings])

  const ReadAddress = (address = {}) => {
    const showNewLine =
      (address.AddressLine1 || address.AddressLine2 || address.AddressLine3) &&
      (address.City || address.StateOrProvince || address.PostalCode)
    return (
      (address.AddressLine1 ? address.AddressLine1 : '') +
      (showNewLine ? '\n' : '') +
      (address.AddressLine2 ? address.AddressLine2 + '\n' : '') +
      (address.AddressLine3 ? address.AddressLine3 + '\n' : '') +
      (address.City ? address.City + ',' : '') +
      ' ' +
      (address.StateOrProvince ? address.StateOrProvince : '') +
      ' ' +
      (address.PostalCode ? address.PostalCode : '')
    )
  }

  const ReadValue = (fieldType, value) => {
    let curratedValue = value || value === false ? value : 'N/A'
    switch (fieldType) {
      case 0:
        //console.log(value)
        break
      case 2:
        return ReadAddress(curratedValue)
      case 4:
        return value ? format(new Date(curratedValue), 'MM/dd/yyyy') : curratedValue
      case 16:
        return value ? value.Name : ''
      case 32:
        return <Checkbox checked={value} disabled={true} ariaLabel={`Checkbox`} />
      case 64:
        return value ? 'Good' : 'Bad'
      case 128:
        return value
      default:
        console.error('Uncertain Field Type: ' + fieldType + ' for value: ' + value)
        break
    }
    return value
  }

  const tableRows = useMemo(() => {
    const rows = records.map((party, i) => {
      const row = {
        id: i,
      }
      Object.keys(fieldSettings).forEach((key) => {
        Object.assign(row, { [key]: ReadValue(fieldSettings[key].FieldType || 0, party[key]) })
      })
      return row
    })
    return rows
  }, [records])

  return (
    <div
      className="row"
      style={{ marginBottom: '80px', display: 'flex', flexDirection: 'row', gap: '20px' }}
    >
      <h2>Represented Records</h2>
      <GraniteDataGrid
        getRowId={(row) => row.id}
        columns={template}
        rows={tableRows}
        onRowDoubleClick={(e) =>
          history.push(`/recordDetails/BusinessEntitySearch/${e.row.RecordNum}`)
        }
      />
    </div>
  )
}

export default RepresentedBusinessRecords
